module.exports = __webpack_public_path__ + "img/banner1.97617889.png";